import { useSubFlowFieldsContext } from '../context';
import { FlowArguments, type FlowArgumentsProps } from './FlowArguments';

type SharedFlowArgumentsProps = Omit<FlowArgumentsProps, 'inputSchema'>;

/**
 * Must be wrapped in a SubFlowFieldsProvider
 */
export function SharedFlowArguments(props: SharedFlowArgumentsProps) {
  const { flowDefinitionResult } = useSubFlowFieldsContext();
  const flowDefinition = flowDefinitionResult.data;
  const inputSchema = flowDefinition?.data.inputSchema;
  return <FlowArguments {...props} inputSchema={inputSchema} />;
}
